export const GET_ADDRESSES = "GET_ADDRESSES";
export const SAVE_ADDRESS = "SAVE_ADDRESS";
export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const SET_DEFAULT = "SET_DEFAULT";
